import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleGoogleOAuthCode } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const params = new URLSearchParams(location.search);
      const code = params.get('code');

      if (code) {
        try {
          const redirectUri = window.location.origin + '/auth/callback';
          const user = await handleGoogleOAuthCode(code, redirectUri);
          // Route based on account state to avoid an extra redirect hop via ProtectedRoute
          if (user?.role === 'client' && user?.email_verified === false) {
            navigate('/verify-email-sent', { replace: true });
          } else if (user?.role === 'client' && user?.onboarding_completed === false) {
            navigate('/onboarding', { replace: true });
          } else if (user?.role === 'client' && !user?.package_type) {
            navigate('/dashboard/billing?from=onboarding', { replace: true });
          } else {
            navigate('/dashboard', { replace: true });
          }
        } catch (error) {
          console.error('OAuth callback error:', error);
          navigate('/login', { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [handleGoogleOAuthCode, location.search, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-indigo-500 mx-auto mb-4" />
        <p className="text-slate-600 dark:text-slate-400">Completing sign in...</p>
      </div>
    </div>
  );
}
